import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const Container = styled(Accordion.Item) `
  &:not(:last-child) {
    border-bottom: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  }
  padding: ${themeGet('spacing.xl')};
`;
